// src/components/dev/GoogleMap/GoogleMap.tsx
import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";

// Styled components
const MapWrapper = styled.div`
  width: 100%;
  max-width: 1200px; /* Matches .content-section max-width from style.css */
  margin: 20px auto; /* Consistent spacing */
  border-radius: 8px;
  overflow: hidden; /* Ensures iframe fits neatly */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Matches .feature-card shadow */
`;

const MapContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio for responsiveness */
  height: 0;
  background: #333; /* Fallback background */
`;

const MapIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

// Define props interface for TypeScript
interface GoogleMapProps {
  mapUrl?: string;
  title?: string;
  ariaLabel?: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ mapUrl, title, ariaLabel }) => {
  // Default values if props aren’t provided
  const defaultMapUrl = "https://www.google.com/maps/d/u/0/embed?mid=1IeLInyV7cTtRSFS6fZj-VrbsQkA&ehbc=2E312F";
  const defaultTitle = "OneLightSystem OLS Location Map";
  const defaultAriaLabel = "Interactive map showing OneLightSystem OLS location";

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Place",
            "name": "OneLightSystem OLS Location",
            "url": "https://www.olsme.com",
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "37.7749", // Example: Replace with actual coordinates
              "longitude": "-122.4194", // Example: Replace with actual coordinates
            },
            "description": "Explore the location of OneLightSystem OLS on our interactive Google Map.",
          })}
        </script>
      </Helmet>

      <MapWrapper>
        <MapContainer className="iframe-container">
          <MapIframe
            src={mapUrl || defaultMapUrl}
            allowFullScreen
            loading="lazy"
            title={title || defaultTitle}
            aria-label={ariaLabel || defaultAriaLabel}
            className="google-map-iframe"
          />
        </MapContainer>
      </MapWrapper>
    </>
  );
};

export default GoogleMap;